import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["iconFill"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { createElement } from 'react';
import ReactDOMServer from 'react-dom/server';
import L from 'leaflet';
import { forIn as _forIn } from 'lodash';
import helpers from './helpers';

/**
 * It enables to draw various shapes as marker icon.
 * @augments L.DivIcon
 * @param props {object}
 * @param props.basicShape {bool} If true -> DIV element, if false -> SVG element
 * @param props.icon {Object} Icon definition
 * @param props.icon.component {React.Component}
 * @param props.icon.componentProps {React.Object} Additional icon component props
 * @param props.id {string}
 * @param props.iconAnchor {string} https://leafletjs.com/reference-1.7.1.html#icon-iconanchor
 * @param props.onClick {function} onclick callback
 * @param props.onMouseMove {function} mousemove callback
 * @param props.onMouseOver {function} mouseover callback
 * @param props.onMouseOut {function} mouseout callback
 * @param props.shape {Object} Shape definition
 * @param props.shape.component {React.Component}
 * @param props.shape.componentProps {React.Object} Additional shape component props
 * @param props.style {string} Extended Leaflet style (see getSvgStyle method for details)
 */
import { jsx as _jsx } from "react/jsx-runtime";
var MarkerShape = /*#__PURE__*/function (_L$DivIcon) {
  _inherits(MarkerShape, _L$DivIcon);
  var _super = _createSuper(MarkerShape);
  function MarkerShape(props) {
    var _this;
    _classCallCheck(this, MarkerShape);
    _this = _super.call(this, props);

    // Needed by L.DivIcon
    _this.iconAnchor = props.iconAnchor;
    _this.basicShape = props.basicShape;
    _this.id = props.id;
    _this.style = props.style;
    _this.shape = props.shape;
    _this.icon = props.icon;
    _this.onMouseMove = props.onMouseMove;
    _this.onMouseOver = props.onMouseOver;
    _this.onMouseOut = props.onMouseOut;
    _this.onClick = props.onClick;
    return _this;
  }

  /**
   * Overwrite ancestor's method
   * @param oldShape
   * @return {HTMLDivElement}
   */
  _createClass(MarkerShape, [{
    key: "createIcon",
    value: function createIcon(oldShape) {
      var div;
      if (oldShape && oldShape.tagName === 'DIV') {
        div = oldShape;
      } else {
        div = document.createElement('div');
        div.id = this.id;
        if (this.onMouseMove) {
          div.addEventListener('mousemove', this.onMouseMove);
        }
        if (this.onMouseOver) {
          div.addEventListener('mouseover', this.onMouseOver);
        }
        if (this.onMouseOut) {
          div.addEventListener('mouseout', this.onMouseOut);
        }
        if (this.onClick) {
          div.addEventListener('click', this.onClick);
        }
      }
      var html = this.getShapeHtml();
      if (html instanceof Element) {
        div.appendChild(html);
      } else {
        div.innerHTML = html !== false ? html : '';
      }
      this._setIconStyles(div, 'icon');
      return div;
    }

    /**
     * Prepare html of the icon based on shape and icon components
     * @return {string}
     */
  }, {
    key: "getShapeHtml",
    value: function getShapeHtml() {
      // Basic shape -> no need for svg
      if (this.basicShape) {
        var style = helpers.getMarkerShapeCssStyle(this.style);
        return ReactDOMServer.renderToString( /*#__PURE__*/_jsx("div", {
          style: style
        }));
      } else {
        var finalShape;
        var _style = helpers.getMarkerShapeSvgStyle(this.style);

        // Combined shape and icon
        // Currently only shape="pin" is suitable for combination
        if (this.shape && this.icon) {
          finalShape = this.getShapeWithIcon(_style);
        }

        // Just shape
        else if (this.shape) {
          finalShape = this.getShape(_style);
        }

        // No shape, but icon? Use icon as shape
        else if (this.icon) {
          finalShape = this.getIcon(_style);
        }
        return ReactDOMServer.renderToString(finalShape);
      }
    }

    /**
     * @param style {Object} style object suitable for SVG
     * @return {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>}
     */
  }, {
    key: "getShape",
    value: function getShape(style) {
      var props = this.shape.componentProps ? _objectSpread(_objectSpread({}, this.shape.componentProps), {}, {
        style: style
      }) : {
        style: style
      };
      return /*#__PURE__*/createElement(this.shape.component, _objectSpread(_objectSpread({}, props), {}, {
        outlineWidth: this.style.weight
      }));
    }

    /**
     * @param style {Object} style object suitable for SVG
     * @return {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>}
     */
  }, {
    key: "getIcon",
    value: function getIcon(style) {
      var iconStyle = _objectSpread(_objectSpread({}, style), {}, {
        fill: style.iconFill ? style.iconFill : style.fill
      });
      var props = this.icon.componentProps ? _objectSpread(_objectSpread({}, this.icon.componentProps), {}, {
        style: iconStyle
      }) : {
        style: iconStyle
      };
      return /*#__PURE__*/createElement(this.icon.component, props);
    }

    /**
     * @param style {Object} style object suitable for SVG
     * @return {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>}
     */
  }, {
    key: "getShapeWithIcon",
    value: function getShapeWithIcon(style) {
      var iconStyle = {
        strokeWidth: 0
      }; // TODO think about icons styling inside shape
      var iconFill = style.iconFill,
        shapeStyle = _objectWithoutProperties(style, _excluded);
      if (iconFill) {
        iconStyle.fill = iconFill;
      } else {
        iconStyle.fill = shapeStyle.stroke;
      }
      var iconProps = this.icon.componentProps ? _objectSpread(_objectSpread({}, this.icon.componentProps), {}, {
        style: iconStyle
      }) : {
        style: iconStyle
      };
      var iconComponent = /*#__PURE__*/createElement(this.icon.component, iconProps);
      var props = this.shape.componentProps ? _objectSpread(_objectSpread({}, this.shape.componentProps), {}, {
        style: shapeStyle
      }) : {
        style: shapeStyle
      };
      return /*#__PURE__*/createElement(this.shape.component, _objectSpread(_objectSpread({}, props), {}, {
        icon: iconComponent,
        outlineWidth: this.style.weight
      }));
    }

    /**
     * Set style of element
     * @param style {Object} Leaflet style definition
     * @param id {string} id of the shape
     * @param isBasicShape {bool} If true -> DIV element, if false -> SVG element
     */
  }, {
    key: "setStyle",
    value: function setStyle(style, id, isBasicShape) {
      var _element$children;
      id = id || this.id;
      isBasicShape = isBasicShape || this.basicShape;
      var shapeStyle = isBasicShape ? helpers.getMarkerShapeCssStyle(style) : helpers.getMarkerShapeSvgStyle(style);
      var element = document.getElementById(id);
      var shape = element === null || element === void 0 ? void 0 : (_element$children = element.children) === null || _element$children === void 0 ? void 0 : _element$children[0];
      if (shape) {
        _forIn(shapeStyle, function (value, key) {
          shape.style[key] = value;
        });
      }
    }
  }]);
  return MarkerShape;
}(L.DivIcon);
export default MarkerShape;